import React, { useMemo } from 'react';
import {
  Box,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

const HypothecationChangeDetails = ({ data }) => {

  const rows = useMemo(() => {
    let list = [];

    if (data?.updates?.length) {
      data.updates.forEach((item) => {
        list.push({
          type: 'updated',
          particulars: 'Financier details modified',
          bank: item?.newValue?.bank || item?.bank,
          branch: item?.newValue?.branch || item?.branch,
        });
      });
    }

    if (data?.new?.length) {
      data.new.forEach((item) => {
        list.push({
          type: 'new',
          particulars: 'Newly added Financier name',
          bank: item?.bank,
          branch: item?.branch,
        });
      });
    }

    if (data?.deleted?.length) {
      data.deleted.forEach((item) => {
        list.push({
          type: 'deleted',
          particulars: 'Financier name to be removed',
          bank: item?.bank,
          branch: item?.branch,
        });
      });
    }

    return list;
  }, [data]);

  // Safe conditional rendering AFTER hook
  if (!rows.length) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid #d9d9d9',
        mb: 2,
        overflow: 'hidden',
        borderRadius: '0px',
      }}
    >
      {/* Blue Header */}
      <Box
        sx={{
          backgroundColor: '#5569ff',
          color: '#fff',
          px: '8px',
          py: '4px',
         
        }}
      >
        Change in Hypothecation Details
      </Box>

      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#f3f4f6' }}>
            <TableCell sx={{ fontWeight: 600 }}>Sl No</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Particulars</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Financier Name</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Branch</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{row.particulars}</TableCell>
              <TableCell>{row.bank}</TableCell>
              <TableCell>{row.branch}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default HypothecationChangeDetails;